// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttons {
  display: flex;
  justify-content: center;
  gap: 1rem;
}
.buttons button {
  font-family: "Montserrat";
}
.buttons button mat-icon {
  transform: scale(2);
}
.buttons button .subtitle-what-new {
  font-size: 14px;
  display: flex;
  font-weight: 500;
}

.button-container {
  display: flex;
  -moz-column-gap: 1rem;
       column-gap: 1rem;
}

.loader {
  height: 20vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-button {
  position: absolute;
}
.back-button.left {
  top: 0;
  left: 0;
  margin-left: 15px;
  margin-top: 15px;
}
.back-button.right {
  top: 0;
  right: 0;
  margin-right: 15px;
  margin-top: 15px;
}

h2 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

::ng-deep .paginator-container {
  align-items: center;
  justify-content: center;
}
::ng-deep .paginator-container .mat-mdc-paginator-range-label {
  display: none;
}

.current-version-txt {
  font-size: small;
  color: var(--font-gray);
}

.versions-list {
  text-align: left;
}
.versions-list mat-list-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.img-container {
  margin-top: 2rem;
  overflow: hidden;
  padding-bottom: 0.1rem;
}

::ng-deep .icon-button.action-button > .mdc-button__label {
  font-size: smaller;
}
::ng-deep .icon-button .mat-mdc-button-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
}

.centered-text {
  text-align: center;
  padding: 0;
  margin: 0;
}

.title, .title_platform {
  font-weight: 500;
}

.title, .content {
  margin-right: auto;
  margin-left: 1em;
}

.content {
  margin-bottom: 2em;
}

a {
  cursor: pointer;
}

::ng-deep .changelog-container h2 {
  margin-top: 0;
}
::ng-deep .changelog-container h1, ::ng-deep .changelog-container h2, ::ng-deep .changelog-container h3, ::ng-deep .changelog-container h4, ::ng-deep .changelog-container h5, ::ng-deep .changelog-container p {
  text-align: left;
}
::ng-deep .changelog-container ul {
  text-align: left;
  padding-inline: 1.6rem;
}

.checkbox-container {
  display: flex;
  align-items: center;
  margin-top: 2em;
  justify-content: center;
}

.confirm-button-container {
  display: flex;
  justify-content: flex-end;
}

.terminos-footer {
  text-transform: capitalize;
}

.no-results {
  text-align: center;
  padding: 20px;
  color: gray;
}

.titulo-alerta {
  font-weight: 400;
}

.message-close-dialog-about {
  font-weight: 300;
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/dialogs/acerca-de/acerca-de.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,SAAA;AACJ;AACI;EACI,yBAAA;AACR;AACQ;EACI,mBAAA;AACZ;AAEQ;EACI,eAAA;EACA,aAAA;EACA,gBAAA;AAAZ;;AAKA;EACI,aAAA;EACA,qBAAA;OAAA,gBAAA;AAFJ;;AAKA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFJ;;AAKA;EACI,kBAAA;AAFJ;AAII;EACI,MAAA;EACA,OAAA;EACA,iBAAA;EACA,gBAAA;AAFR;AAKI;EACI,MAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;AAHR;;AAOA;EACI,wBAAA;EACA,2BAAA;AAJJ;;AAOA;EACI,mBAAA;EACA,uBAAA;AAJJ;AAMI;EACI,aAAA;AAJR;;AAQA;EACI,gBAAA;EACA,uBAAA;AALJ;;AAQA;EACI,gBAAA;AALJ;AAOI;EACI,4CAAA;AALR;;AASA;EACI,gBAAA;EACA,gBAAA;EACA,sBAAA;AANJ;;AAWI;EACI,kBAAA;AARR;AAWI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AATR;;AAaA;EACI,kBAAA;EACA,UAAA;EACA,SAAA;AAVJ;;AAYA;EACI,gBAAA;AATJ;;AAWA;EACI,kBAAA;EACA,gBAAA;AARJ;;AAUA;EACI,kBAAA;AAPJ;;AASA;EACI,eAAA;AANJ;;AAUI;EACI,aAAA;AAPR;AAUI;EACI,gBAAA;AARR;AAWI;EACI,gBAAA;EACA,sBAAA;AATR;;AAaA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;AAVJ;;AAaA;EACI,aAAA;EACA,yBAAA;AAVJ;;AAaA;EACI,0BAAA;AAVJ;;AAaA;EACI,kBAAA;EACA,aAAA;EACA,WAAA;AAVJ;;AAaA;EACI,gBAAA;AAVJ;;AAaA;EACI,gBAAA;EACA,eAAA;AAVJ","sourcesContent":[".buttons {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 1rem;\r\n\r\n    button {\r\n        font-family: \"Montserrat\";\r\n\r\n        mat-icon {\r\n            transform: scale(2);\r\n        }\r\n\r\n        .subtitle-what-new {\r\n            font-size: 14px;\r\n            display: flex;\r\n            font-weight: 500;\r\n        }\r\n    }\r\n}\r\n\r\n.button-container {\r\n    display: flex;\r\n    column-gap: 1rem;\r\n}\r\n\r\n.loader {\r\n    height: 20vh;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.back-button {\r\n    position: absolute;\r\n    \r\n    &.left {\r\n        top: 0;\r\n        left: 0;\r\n        margin-left: 15px;\r\n        margin-top: 15px;\r\n    }\r\n\r\n    &.right {\r\n        top: 0;\r\n        right: 0;\r\n        margin-right: 15px;\r\n        margin-top: 15px;\r\n    }\r\n}\r\n\r\nh2{\r\n    margin-top: 0 !important;\r\n    margin-bottom: 0 !important;\r\n}\r\n\r\n::ng-deep  .paginator-container {\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    .mat-mdc-paginator-range-label {\r\n        display: none;\r\n    }\r\n}\r\n\r\n.current-version-txt {\r\n    font-size: small;\r\n    color: var(--font-gray);\r\n}\r\n\r\n.versions-list {\r\n    text-align: left;\r\n\r\n    mat-list-item {\r\n        border-bottom: 1px solid rgba(0, 0, 0, 0.12);\r\n    }\r\n}\r\n\r\n.img-container {\r\n    margin-top: 2rem;\r\n    overflow: hidden;\r\n    padding-bottom: .1rem;\r\n}\r\n\r\n::ng-deep .icon-button {\r\n\r\n    &.action-button>.mdc-button__label {\r\n        font-size: smaller;\r\n    }\r\n\r\n    .mat-mdc-button-wrapper {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 4px;\r\n    }\r\n}\r\n\r\n.centered-text {\r\n    text-align: center;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n.title, .title_platform{\r\n    font-weight: 500;\r\n}\r\n.title, .content{\r\n    margin-right: auto;\r\n    margin-left: 1em;\r\n}\r\n.content{\r\n    margin-bottom: 2em;\r\n}\r\na{\r\n    cursor: pointer;\r\n}\r\n\r\n::ng-deep .changelog-container {\r\n    h2 {\r\n        margin-top: 0;\r\n    }\r\n\r\n    h1,h2 ,h3,h4, h5, p {\r\n        text-align: left;\r\n    }\r\n    \r\n    ul {\r\n        text-align: left;\r\n        padding-inline: 1.6rem;\r\n    }\r\n}\r\n\r\n.checkbox-container {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-top: 2em;\r\n    justify-content: center;\r\n}\r\n  \r\n.confirm-button-container {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.terminos-footer {\r\n    text-transform: capitalize;\r\n}\r\n\r\n.no-results {\r\n    text-align: center;\r\n    padding: 20px;\r\n    color: gray;\r\n}\r\n\r\n.titulo-alerta {\r\n    font-weight: 400;\r\n}\r\n\r\n.message-close-dialog-about { \r\n    font-weight: 300;\r\n    font-size: 20px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
